var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuidlines = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 5A3.5 3.5 0 0 1 5 1.5h13v1H5a2.5 2.5 0 0 0-2.45 2H18.5v14h-17zm1 .5v12h15v-12z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 7.5a2 2 0 0 0-2 2v.5H7v-.5a3 3 0 0 1 3-3h.546a2.454 2.454 0 0 1 1.361 4.496l-.63.42A2.87 2.87 0 0 0 10 13.803v.697H9v-.697c0-1.294.646-2.501 1.723-3.219l.63-.42a1.454 1.454 0 0 0-.807-2.664zM9 16v-.5h1v.5z",
  clipRule: "evenodd"
})));
export default SvgGuidlines;